import React, { useState } from 'react';
import 'react-day-picker/dist/style.css';
import styled from 'styled-components';
import Dropdown from './Dropdown';
import { createClienteAux, uploadToS3, updateContactById, updateContactClient, getContactByID } from "../../../../endpoints"
import Swal from "sweetalert2";
export default function CrearCliente(
    {
        // contacto,

        closeCreateNuevoCliente,
        stopPropagation,
        setSeActualizoContacto,
        getContacts,
        getClientes,
        setClientes,
        setContacts,
        scrollContainerRef,
        user,
        contacto,
        getContactID
    }) {
    const [nroDePoliza, setNroDePoliza] = useState();
    const [tipoDeSeguro, setTipoDeSeguro] = useState();
    const [provedorDeSeguro, setProvedorDeSeguro] = useState();
    const [fechaDeEmision, setFechaDeEmision] = useState();
    const [fechaDeVencimiento, setFechaDeVencimiento] = useState();
    const [metodoDePago, setMetodoDePago] = useState();
    const [documentacion, setDocumentacion] = useState();
    const [nombre, setNombre] = useState(contacto?.name || "");
    const [apellido, setApellido] = useState(contacto?.lastname || "");
    const [telefono, setTelefono] = useState(contacto?.phone || "");
    const [email, setEmail] = useState(contacto?.email || "");
    const [loading, setLoading] = useState(false);

    const optionTipoDeSeguro = [
        "Auto",
        "Moto",
        "Incendio",
        "Combinado Familiar",
        "Viajes",
        "Sepelio",
        "Retiro",
        "Accidente Personal",
        "Monopatin",
        "Bicicleta",
        "Embarcaciones de Placer",
        "Moto de Agua de Jet-Sky",
        "Integral comercio",
        "ART",
        "Caución",
        "Todo riesgo operativo",
        "Riesgo técnico",
        "Granizo",
        "Maquinaria",
        "Hacienda",
        "Silo/Silobolsa",
        "Equipos Electronicos",
        "Transporte de ganado y cereales"
    ]
    const optionsProvedoresDeSeguros = [
        "Federacion Patronal",
        "Grupo Sancor",
        "Provincia",
        "Swiss Medical",
        "Galeno",
        "Provincia Seguros",
        "Provincia ART",
        "Mercantil Andina",
        "ATM",
        "Providencia"
    ]
    const optionsMetodoDePago = [
        "Efectivo",
        "Débito",
        "Crédito",
        "Otro"

    ]


    const handleTextAreareaOnChange = (e) => {

        if (e.target.name === "nombre") {
            setNombre(e.target.value)
        }
        if (e.target.name === "apellido") {
            setApellido(e.target.value)
        }
        if (e.target.name === "telefono") {
            setTelefono(e.target.value)
        }
        if (e.target.name === "email") {
            setEmail(e.target.value)
        }
        if (e.target.name === "nroDePoliza") {
            setNroDePoliza(e.target.value)
        }
        if (e.target.name === "fechaDeVencimiento") {
            setFechaDeVencimiento(e.target.value)
        }
        if (e.target.name === "fechaDeEmision") {
            setFechaDeEmision(e.target.value)
        }
        if (e.target.name === "documentacion") {

            e.preventDefault();
            setLoading(true);

            try {
                const formData = new FormData();
                formData.append('file', e.target.files[0]);

                uploadToS3(formData).then((response) => {
                    if (response?.status === 200) {
                        setDocumentacion(response.data.photoUrl)
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                    console.log('Respuesta del servidor:', response?.data);
                });


                // Aquí podrías añadir lógica adicional para manejar la respuesta del servidor, como mostrar un mensaje de éxito al usuario.
            } catch (error) {
                console.error('Error al enviar la solicitud:', error);
                // Aquí podrías añadir lógica adicional para manejar errores, como mostrar un mensaje de error al usuario.
                setLoading(false);
            }

        }

    }



    const handleGuardar = () => {
        // Obtener la fecha seleccionada
        console.log(
            // contacto?.id,
            user.id
        )

        setLoading(true)
        if (contacto?.id) {
            updateContactClient({
                id: contacto.id,
                name: nombre,
                lastname: apellido,
                email: email,
                phone: telefono

            }).then((res) => {
                if (res.status === 200) {
                    Swal.fire({
                        icon: "success",
                        title: "Se actualizó con exito",
                        confirmButtonText: "Listo",
                        confirmButtonColor: "#003049",
                        customClass: {
                            title: 'my-custom-title-class'
                        }
                    });
                    setSeActualizoContacto(true)
                    setClientes([])
                    getClientes().then(() => {
                        closeCreateNuevoCliente()
                    });
                    getContactID()
                    setLoading(false)
                } else {
                    console.log(res)
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        confirmButtonText: "Listo",
                        confirmButtonColor: "#003049",
                        customClass: {
                            title: 'my-custom-title-class'
                        }
                    });
                    setLoading(false)
                }
            })
        } else {
            if (
                nroDePoliza &&
                tipoDeSeguro &&
                provedorDeSeguro &&
                fechaDeVencimiento &&
                metodoDePago &&
                nombre &&
                apellido &&
                telefono &&
                email &&

                user?.id
            ) {
                createClienteAux({
                    nombre: nombre,
                    email: email,
                    apellido: apellido,
                    telefono: telefono,
                    nroDePoliza: nroDePoliza,
                    tipoDeSeguro: tipoDeSeguro,
                    provedorDeSeguro: provedorDeSeguro,
                    fechaDeEmision: fechaDeEmision,
                    fechaDeVencimiento: fechaDeVencimiento,
                    metodoDePago: metodoDePago,

                    asesorAsignado: user?.id,
                    archivoAdjunto: documentacion
                }).then((res) => {
                    if (res.status === 200 || res.status === 201) {
                        console.log(res)
                        console.log("SE ACTUALIZO")

                        Swal.fire({
                            icon: "success",
                            title: "Se creo con exito",
                            confirmButtonText: "Listo",
                            confirmButtonColor: "#003049",
                            customClass: {
                                title: 'my-custom-title-class'
                            }
                        });
                        setSeActualizoContacto(true)
                        setClientes([])
                        getClientes().then(() => {
                            closeCreateNuevoCliente()
                        });
                        setLoading(false)

                    } else {
                        console.log(res)
                        Swal.fire({
                            icon: "error",
                            title: "Error",
                            confirmButtonText: "Listo",
                            confirmButtonColor: "#003049",
                            customClass: {
                                title: 'my-custom-title-class'
                            }
                        });
                        setLoading(false)
                    }
                })
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Complete los campos obligatorios",
                    confirmButtonText: "Listo",
                    confirmButtonColor: "#003049",
                    customClass: {
                        title: 'my-custom-title-class'
                    }
                });
                setLoading(false)
            }
        }

    };



    const handleCancelar = () => {
        closeCreateNuevoCliente();

    };

    console.log(contacto, "linea 236 create cliente modal")


    return (
        <ModalWrapper onClick={handleCancelar}>
            <ModalContent onClick={stopPropagation}>

                {
                    contacto?.id ?
                        <span>Formulario de edición de Cliente *</span>
                        :
                        <span>Formulario de creación de Cliente *</span>
                }

                <div
                    style={{

                        width: "100%",
                        display: "flex",
                        flexDirection: "column",

                        gap: "2px"
                    }}
                >
                    <span>Nombre *</span>
                    <InputCust
                        name="nombre"
                        placeholder='Ingrese Nombre'
                        value={nombre || ""}
                        onChange={(e) => handleTextAreareaOnChange(e)}
                    />
                </div>
                <div
                    style={{

                        width: "100%",
                        display: "flex",
                        flexDirection: "column",

                        gap: "2px"
                    }}
                >
                    <span>Apellido *</span>
                    <InputCust
                        name="apellido"
                        placeholder='Ingrese Apellido'
                        value={apellido || ""}
                        onChange={(e) => handleTextAreareaOnChange(e)}
                    />
                </div>
                <div
                    style={{

                        width: "100%",
                        display: "flex",
                        flexDirection: "column",

                        gap: "2px"
                    }}
                >
                    <span>Teléfono *</span>
                    <InputCust
                        name="telefono"
                        placeholder='Ingrese Teléfono'
                        value={telefono || ""}
                        onChange={(e) => handleTextAreareaOnChange(e)}
                    />
                </div>
                <div
                    style={{

                        width: "100%",
                        display: "flex",
                        flexDirection: "column",

                        gap: "2px"
                    }}
                >
                    <span>Email</span>
                    <InputCust
                        name="email"
                        placeholder='Ingrese Email'
                        value={email || ""}
                        onChange={(e) => handleTextAreareaOnChange(e)}
                    />
                </div>
                {
                    contacto?.id ? null :
                        <>
                            <span>Datos de Poliza *</span>
                            <div
                                style={{

                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",

                                    gap: "2px"
                                }}
                            >
                                <span>N° de poliza*</span>
                                <InputCust
                                    name="nroDePoliza"
                                    placeholder='ej:11223344'

                                    onChange={(e) => handleTextAreareaOnChange(e)}
                                />
                            </div>
                            <div
                                style={{

                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",

                                    gap: "2px"
                                }}
                            >
                                <span style={{
                                    fontFamily: "'Montserrat', sans-serif"
                                }}>Tipo de seguro *</span>
                                <Dropdown
                                    Containerwidth={'100%'}
                                    options={optionTipoDeSeguro}
                                    selectedOption={tipoDeSeguro}
                                    setSelectedOption={setTipoDeSeguro}
                                />
                            </div>

                            <div
                                style={{

                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",

                                    gap: "2px"
                                }}
                            >
                                <span style={{
                                    fontFamily: "'Montserrat', sans-serif"
                                }}>Provedor de seguro*</span>
                                <Dropdown
                                    Containerwidth={'100%'}
                                    options={optionsProvedoresDeSeguros}
                                    selectedOption={provedorDeSeguro}
                                    setSelectedOption={setProvedorDeSeguro}
                                />
                            </div>

                            <div
                                style={{

                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",

                                    gap: "2px"
                                }}
                            >
                                <span>Fecha de Emisión*</span>
                                <InputCust
                                    type="date"
                                    name="fechaDeEmision"
                                    placeholder='ej:11223344'

                                    onChange={(e) => handleTextAreareaOnChange(e)}
                                />
                            </div>
                            <div
                                style={{

                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",

                                    gap: "2px"
                                }}
                            >
                                <span>Fecha de vencimiento*</span>
                                <InputCust
                                    type="date"
                                    name="fechaDeVencimiento"
                                    placeholder='ej:11223344'

                                    onChange={(e) => handleTextAreareaOnChange(e)}
                                />
                            </div>

                            <div
                                style={{

                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",

                                    gap: "2px"
                                }}
                            >
                                <span>Metodo de pago*</span>
                                <Dropdown
                                    Containerwidth={'100%'}
                                    options={optionsMetodoDePago}
                                    selectedOption={metodoDePago}
                                    setSelectedOption={setMetodoDePago}
                                />
                            </div>

                            <div
                                style={{

                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",

                                    gap: "2px"
                                }}
                            >
                                <span>Documentación</span>
                                <InputCust
                                    type="file"
                                    name="documentacion"
                                    placeholder='ej:11223344'

                                    onChange={(e) => handleTextAreareaOnChange(e)}
                                />
                            </div>
                        </>
                }


                <ButtonGroup>
                    <Button style={{
                        backgroundColor: '#780000',
                    }} onClick={handleCancelar}>CANCELAR</Button>
                    <Button style={{
                        backgroundColor: '#003049',
                    }} onClick={handleGuardar}
                        disabled={loading}
                    >GUARDAR</Button>
                </ButtonGroup>
            </ModalContent>
        </ModalWrapper>
    );
}

// Componente de selección de hora y minutos


const CloseIconImg = styled.img`
  max-width:24px;
  max-height:28px;
  width:24px;
  height:28px;
  cursor:pointer;
  user-select: none;
  &:hover {
    transform: scale(1.1)
  }
`;
const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  padding: 30px;
  width: -webkit-fill-available;
  max-width:400px;
  padding: 20px auto;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  max-height:60vh;
  overflow-y: auto;
  display:flex;
  flex-direction: column;
  align-items: flex-start;
  gap:16px;
  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }
  @media screen and (min-width:0px) and (max-width: 1100px) {
    max-height:80vh;
    margin-top:10vh;
  }
`;

const Button = styled.button`
  padding: 10px 20px;
  margin-top: 10px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-weight:500;
  font-family: 'Montserrat', sans-serif;
  &:hover {
    background-color: #0056b3;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  // border:solid 1px red;
  width:-webkit-fill-available;
  justify-content: space-between;
  align-items: center;
`;

const TimeInput = styled.input`
  margin-top: 10px;
  padding: 10px 20px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  min-height:20px;
  
  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

const InputCust = styled.input`
  margin-top: 0px;
  padding: 10px 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: -webkit-fill-available !important;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  
  resize: none;
  &:placeholder{
    font-family: 'Montserrat', sans-serif;
  }
  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
`;
const TextArea = styled.textarea`
  margin-top: 10px;
  padding: 10px 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: -webkit-fill-available !important;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 12px;
  min-height:80px;
  resize: none;
  &:placeholder{
    font-family: 'Montserrat', sans-serif;
  }
  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
`;